import ApiUtils from "../ApiUtils";

export default class ApiAdminService {

    async getAllAdminUsers() {
        return await ApiUtils.callApi('admin/all/users','get');
    }

    async loginAsClientTool(data){
        return await ApiUtils.callApi('client/login','post', data, 'clienttool'); // Calling student portal api // true
    }

    // Company Fee Setting
    async getCompanyFeeSettings(companyId){
        return await ApiUtils.callApi(`admin/company/fee/${companyId}`,'get');
    }

    async updateCompanyFeeSettings(data){
        return await ApiUtils.callApi(`admin/company/fee`,'post',data);
    }

    // Student Page Setting
    async getStudentPageSettings(companyId){
        return await ApiUtils.callApi(`admin/student/page/settings/${companyId}`,'get');
    }

    async updateStudentPageSettings(data){
        return await ApiUtils.callApi(`admin/student/page/settings`,'post',data);
    }

    // General Settings
    async getGeneralSettings(){
        return await ApiUtils.callApi(`admin/general/settings`,'get');
    }

    async updateGeneralSettings(data){
        return await ApiUtils.callApi(`admin/general/settings`,'post',data);
    }

    // Admin user add edit
    async addAdminUser(data){
        return await ApiUtils.callApi(`admin/add/user`,'post', data);
    }

    async getAAdminUser(adminId){
        return await ApiUtils.callApi(`admin/user/${adminId}`,'get');
    }
    
    async updateAAdminUser(data){
        return await ApiUtils.callApi(`admin/update/user`,'post', data);
    }
}